/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import React from 'react';
import PropTypes from 'prop-types';
import MemberStore from '../../stores/MemberStore';
import MemberImage from './MemberImage';
import MemberName from './MemberName';
import VipBadge from '../vip/VipBadge';

const MembersBlockItemVip = (props) => {
  const { memberId, imageType } = props;
  let { member } = props;
  if (!member) {
    member = MemberStore.get(memberId);
  }

  return (
    <a
      href="/"
      className="member membersBlock-item member--vip"
      data-alert="txt: Darbība veikta, lietotājam atrodoties VIP režīmā."
    >
      <div className="member-image">
        <MemberImage
          member={member}
          memberId={member._id}
          type={imageType}
          key={member._id}
          vipOn
          hideIcons
        />
      </div>
      <div className="member-info">
        <div className="memberName">
          <MemberName
            key={member._id}
            memberId={member._id}
            truncate={17}
            hideAnswerScore
            hideAge
          />
        </div>
      </div>
    </a>
  );
};

MembersBlockItemVip.propTypes = {
  member: PropTypes.shape({
    _id: PropTypes.string,
    verified: PropTypes.bool,
    vip_name: PropTypes.string,
  }),
  memberId: PropTypes.string,
  imageType: PropTypes.string,
};

MembersBlockItemVip.defaultProps = {
  member: null,
  memberId: null,
  imageType: 'o-m',
};

module.exports = MembersBlockItemVip;
